import { useState, useEffect } from 'react'
import { RecruitsAePersonalAPI } from '../services/recruit'

function UserecruitsAePersonal(searchs, code, orgId) {
  const [data, setData] = useState([])
  useEffect(() => {
    const param = {
      page: 1,
      size: 10,
      searchs,
      // code: 'SK65041'
      code,
      orgId
    }
    const getData = async () => {
      const result = await RecruitsAePersonalAPI({ ...param, orgId })
      if (!result) return
      if (result.status) {
        if (result.result.length > 0) {
          const newData = result.result.map((d, i) => {
            return { label: d.rc_no, value: d.rc_no }
          })

          setData(newData)
        } else {
          setData([])
        }
      } else {
        setData([])
      }
    }
    if (orgId) {
      getData()
    }
  }, [searchs, orgId, code])

  return data
}

export default UserecruitsAePersonal
